const environment = process.env.REACT_APP_ENV || 'staging';

const configs = {
  local: {
    apiUrl: "http://localhost:3011",
    s3BucketUrl: "https://local-ezee-boss.s3.us-east-2.amazonaws.com/electronicMail",
    templateId:"68540e0be8a014293921cf59",
    signatureIds: [
      "a09fa889eaf4479bae6c6cb1fdd577a0903fac27ecc74d62b024c2ce1d87d408",
      "e1fda93a014f4b46a490297fd90c7dc6db12a87b987845818834a5fc55dcc7dc",
      "bc342377b82d468db64456dcb92677e062e6e20927f4471f94808f58ab1a5229",
    ],
    appKeys:{
      appSpecificToken: "D5v9pCMJCYeGv5WkB4CcDY2IGcsg18bArh5EmNcFj2koK3cfsjXvMUxafC0y",
      consumerID: "mQGNdN9Pq7ifykiUcnwRUrWep0IF9bhU",
      passPhrase: "1pMJcKBG6AW2b6x4l7Rn2owDM3HzrFol"
    },
    fesPortalUrl:'http://localhost:3000/success',
    environment: "local"
  },
  staging: {
    apiUrl: "https://stage.faceesign.com/backend",
    s3BucketUrl: "https://local-ezee-boss.s3.us-east-2.amazonaws.com/electronicMail",
    templateId:"68552dc0cda6636599c0c9f1",
    signatureIds: [
      "04f8aae7da544fd0b7eeabf7d12a488591c31ab905244df4bab3d7ec8d796a16",
      "8f6d3fe1abf344c98b986508cd2450f016e3d99507ba4d0fb95e436d57face5c",
      "375517de1bbd4a37b450b3f87c6bfc1424d69d044a7a4ee89062a6139160186b",
    ],
    appKeys:{
      appSpecificToken: "E8Pj14rvtne0816Qh6RdaE8aBFjDdoUy4TDI4nzCu2PkTwYKwQlF9rg5kgls",
      consumerID: "2QWBRLBtpch6NptIJ7NCG3iikeZQik6J",
      passPhrase: "rTtr5lREUmom6ufIKwAivDHSzsqmCHm4"
    },
    fesPortalUrl: 'https://home.faceesign.com/',
    environment: "staging"
  },
  uat: {
    apiUrl: "https://stage.faceesign.com/esign_backend",
    s3BucketUrl: "https://local-ezee-boss.s3.us-east-2.amazonaws.com/electronicMail",
    templateId:"69941ce24cb27862c7d6187a",
    signatureIds: [
      "1c8092ae38ba479da5d901e53f475bf17776ec6ceab74ed5b31ef8de0196bc59",
      "33332be8bddd4a36aa52bc47cc1e356012b87c93c4614220909376ed5cc8bf82",
      "2f1ae2457a8b4e7a95ed48ab33f398ee47c844b05a3c46cf94599ba0dbffd493",
    ],
    appKeys:{
      appSpecificToken: "prtn7mLaCfUWvYSNfc3Z1CXEuJZ19eKBFfQ2Ur4ejmOoEQ17deXemnNLgTCY",
      consumerID: "FP1eSuqLasZD6gdLTCvdkWnDfnQqu6Jx",
      passPhrase: "m4fJhxWbXHUgZ8ax0SxdihSXwAbTmbIp"
    },
    fesPortalUrl: 'https://home.faceesign.com/',
    environment: "uat"
},
  production: {
    apiUrl: "https://backend.faceesign.com",
    environment: "production"
  },
};

// need to add the environment keys as config.json in public folder

// let runtimeConfig = null;

// export const loadRuntimeConfig = async () => {
//   const res = await fetch('/config.json');
//   runtimeConfig = await res.json();
//   console.log(runtimeConfig);
// };
// export const getConfig = () => {
//   if (!runtimeConfig) throw new Error('Config not loaded');
//   return runtimeConfig;
// };

// const config = getConfig()[environment];


const config = configs[environment] || configs.staging;

export const {
  apiUrl,
  s3BucketUrl,
  templateId,
  signatureIds,
  fesPortalUrl,
  appKeys,
  environment: env
} = config;

export default config;